import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_GET_EXPORTS_SERVER } from '@/app/module/exports/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetCxUploads = (query: { page?: number; size?: number } = {}) => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const res = esApi.endpoints.getExportsList.useQuery(
    {
      orgId: orgId.toString(),
      functions: 'cxupload',
      ...query,
    },
    { skip: !orgId },
  )

  useEffect(() => {
    if (!res.error) {
      return
    }

    dispatch(
      createNotification({
        'get-cx-uploads-error': {
          type: 'error',
          message: getErrorMessage(res.error, ERROR_GET_EXPORTS_SERVER),
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
